export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "srCollapse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Collapse card"])},
        "srExpand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expand card"])}
      },
      "fr": {
        "srCollapse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réduire le menu"])},
        "srExpand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agrandir le menu"])}
      }
    }
  })
}
